import React from "react";
import { makeAPI } from "../../services/api";
import { error } from "jquery";

export default function Newsletter() {
  const [email, setEmail] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [feedback, setFeedback] = React.useState({ type: "", message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = String(email || "").trim();

    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (regex.test(trimmedEmail)) {
      console.log("Valid Email address");
    } else {
      setFeedback({type:"error",message:"Please enter valid email address."});
      return;
    } 

    if (!trimmedEmail) {
      setFeedback({ type: "error", message: "Please enter your email address." });
      return;
    }

    setIsSubmitting(true);
    setFeedback({ type: "", message: "" });

    try {
      const response = await makeAPI("/api/subscribe_newsletter", "POST", false, {
        subscribe_mail: trimmedEmail,
      });

      if (response?.status === "S") {
        setFeedback({
          type: "success",
          message: response?.message || "Subscription successful.",
        });
        setEmail("");
        return;
      }

      setFeedback({
        type: "error",
        message: response?.message || "Unable to subscribe right now. Please try again.",
      });
    } catch (error) {
      setFeedback({
        type: "error",
        message: "Network error. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="home-newsletter-card">
      <span className="home-connect-chip">Newsletter</span>
      <h3>Get esports rewards, first.</h3>
      <p>
        Join our insider newsletter for tournament alerts, reward campaigns,
        and exclusive member-only promos.
      </p>
      <div className="home-newsletter-stats">
        <div className="home-newsletter-stat">
          <strong>12K+</strong>
          <span>Subscribers</span>
        </div>
        <div className="home-newsletter-stat">
          <strong>5x</strong>
          <span>Weekly Updates</span>
        </div>
      </div>
      <form className="home-newsletter-form" onSubmit={handleSubmit}>
        <label className="sr-only" htmlFor="newsletterEmail">
          Email address
        </label>
        <input
          id="newsletterEmail"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          disabled={isSubmitting}
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Subscribing..." : "Subscribe Now"}
          <i className="fas fa-arrow-right" aria-hidden="true"></i>
        </button>
      </form>
      <small
        className={
          feedback.message
            ? feedback.type === "success"
              ? "home-newsletter-note text-success"
              : "home-newsletter-note text-danger"
            : "home-newsletter-note"
        }
      >
        {feedback.message || "Get instant welcome perks after signup."}
      </small>
      <div className="home-newsletter-points">
        <span>No spam</span>
        <span>Early access events</span>
        <span>1-click unsubscribe</span>
      </div>
    </section>
  );
}
